import { COUNTRY_ATTR, ENTITY_LABEL_OVERRIDES, SR_LABEL_PREFIX } from './DanmarksKortMap.constants.js'

export const formatEntityLabel = (key) =>
  ENTITY_LABEL_OVERRIDES[key] ?? String(key ?? '').replace(/^SR\s+/, `${SR_LABEL_PREFIX} `)

export const getRegionLevelAttr = (flow) =>
  flow === 'sundhedsraad' ? 'sr'
  : flow === 'region'     ? null
  : 'name'

export const getCurrentLevelAttr = (mapLevel, flow) =>
  mapLevel === 'country' ? COUNTRY_ATTR : getRegionLevelAttr(flow)

export const getCountryLevelAttr = (flow) => getRegionLevelAttr(flow) ?? COUNTRY_ATTR

export const getTerminalLevel = (flow) =>
  flow === 'sundhedsraad' ? 'sundhedsraad'
  : flow === 'region'     ? 'region'
  : 'municipality'

export const getTooltipLabel = (groupAttr, key, flow) =>
  (flow === 'municipality' && groupAttr === 'name') ? `${key} kommune` : formatEntityLabel(key)

const ENTITY_PREFIX = /^(?:region|sundhedsr(?:å|aa)d|sr)\s+/

export const normalizeEntityKey = (value) =>
  value == null ? '' : String(value).trim().toLowerCase().replace(ENTITY_PREFIX, '')

export const indexByEntityKey = (data) =>
  new Map((data || []).map(d => [normalizeEntityKey(d.key), d.value]))

const statsIndexes = new WeakMap()

const statsIndexFor = (stats) => {
  let index = statsIndexes.get(stats)
  if (!index) {
    index = new Map()
    Object.entries(stats).forEach(([name, value]) => {
      const normalized = normalizeEntityKey(name)
      if (!index.has(normalized)) index.set(normalized, value)
    })
    statsIndexes.set(stats, index)
  }
  return index
}

export const statsForEntity = (stats, key) => {
  if (!stats || typeof stats !== 'object') return null
  return statsIndexFor(stats).get(normalizeEntityKey(key)) ?? null
}
